<template>
  <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin', 'view_charity']))" class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toast/>
        <Toolbar class="p-mb-4 table-toolbar">
          <template slot="left">
            <Button label="New"
                    v-if="user_accesses && userService.hasAccess(user_accesses, ['admin', 'add_charity'])"
                    icon="pi pi-plus"
                    class="p-button-success p-mr-2"
                    @click="openNew" />
            <Button label="Delete"
                    v-if="user_accesses && userService.hasAccess(user_accesses, ['admin', 'delete_charity'])"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="confirmDeleteSelected"
                    :disabled="!selectedCharities || !selectedCharities.length"/>
          </template>

          <template slot="right">
            <!-- <FileUpload mode="basic" accept="image/*" :maxFileSize="1000000" label="Import" chooseLabel="Import"
                        class="p-mr-2 p-d-inline-block" :disabled="true"/> -->
            <Button label="Export" icon="pi pi-upload" class="p-button-info" @click="exportCSV($event)"/>
          </template>
        </Toolbar>

        <DataTable ref="dt" :value="charities" :selection.sync="selectedCharities" dataKey="id" :paginator="true"
                   :rows="10" :filters="filters"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :rowsPerPageOptions="[5,10,25]"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} charities">
          <template #header>
            <div class="table-header">
              <h5 class="p-m-0">Manage Charities</h5>
              <span class="p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText v-model="filters['global']" placeholder="Search..."/>
                            </span>
            </div>
          </template>

          <Column selectionMode="multiple" headerStyle="width: 4rem"></Column>
          <Column header="Image">
            <template #body="slotProps">
              <img @click="showGallery(slotProps.data)" :src="slotProps.data.image ? 'assets/layout/images/charities/' + slotProps.data.image : 'assets/layout/images/charities/default.jpg'"
                   :alt="slotProps.data.image" class="product-image"/>
            </template>
          </Column>
          <Column field="name" header="Name" sortable></Column>
          <Column field="contact_name" header="Contact" sortable></Column>
          <Column field="contact_mobile" header="Contact No." sortable></Column>
          <!--                    <Column field="rating" header="Reviews" sortable>-->
          <!--                        <template #body="slotProps">-->
          <!--                            <Rating :value="slotProps.data.rating" :readonly="true" :cancel="false" />-->
          <!--                        </template>-->
          <!--                    </Column>-->
          <!-- <Column field="status" header="Status" sortable>
            <template #body="slotProps">
              <span :class="'product-badge status-' + slotProps.data.status.toLowerCase()">{{slotProps.data.status}}</span>
            </template>
          </Column> -->
          <Column>
            <template #body="slotProps">
              <Button :icon="user_accesses && userService.hasAccess(user_accesses, ['admin', 'edit_charity']) ? 'pi pi-pencil' : 'pi pi-eye'"
                      class="p-button-rounded p-button-warning p-mr-2"
                      @click="editCharity(slotProps.data)"/>
              <Button icon="pi pi-trash"
                      class="p-button-rounded p-button-danger"
                      v-if="user_accesses && userService.hasAccess(user_accesses, ['admin', 'delete_charity'])"
                      @click="confirmDeleteCharity(slotProps.data)"/>
            </template>
          </Column>
        </DataTable>

        <div v-if="charities == null" class="loader">
          <scale-out class="loader-style"></scale-out>
        </div>

        <Dialog :visible.sync="charityDialog" :style="{width: '450px'}" header="Charity Details" :modal="true"
                class="p-fluid">
          <img :src="'assets/layout/images/charities/' + charity.image" :alt="charity.image" class="product-image"
               v-if="charity.image"/>
          <div class="p-field">
            <label for="name">Name</label>
            <InputText id="name" v-model.trim="charity.name" required="true" autofocus
                       :class="{'p-invalid': submitted && !charity.name}"/>
            <small class="p-invalid" v-if="submitted && !charity.name">Name is required.</small>
          </div>
          <div class="p-field">
            <label for="description">Description</label>
            <Textarea id="description" v-model="charity.description" required="true" rows="3" cols="20"/>
          </div>

          <div class="p-field">
            <label class="p-mb-3">Company</label>
            <div class="p-formgrid p-grid">
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name1" name="company_name1" value="company_name1"
                             v-model="charity.company_name"/>
                <label for="company_name1">Accessories</label>
              </div>
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name2" name="company_name2" value="company_name2"
                             v-model="charity.company_name"/>
                <label for="company_name2">Clothing</label>
              </div>
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name3" name="company_name3" value="company_name3"
                             v-model="charity.company_name"/>
                <label for="company_name3">Electronics</label>
              </div>
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name4" name="company_name4" value="company_name4"
                             v-model="charity.company_name"/>
                <label for="company_name4">Fitness</label>
              </div>
            </div>
          </div>

          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="contact_number">Contact Number</label>
              <InputNumber id="contact_number" v-model="charity.contact_number" mode="currency" currency="USD"
                           locale="en-US"/>
            </div>
            <div class="p-field p-col">
              <label for="quantity">Quantity</label>
              <InputNumber id="quantity" v-model="charity.quantity" integeronly/>
            </div>
          </div>
          <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
            <Button label="Save" icon="pi pi-check" class="p-button-text" @click="saveCharity"/>
          </template>
        </Dialog>


        <Dialog :visible.sync="deleteCharityDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="charity">Are you sure you want to delete <b>{{charity.name}}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteCharityDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteCharity"/>
          </template>
        </Dialog>

        <Dialog :visible.sync="deleteCharitiesDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="charity">Are you sure you want to delete the selected charities?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteCharitiesDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedCharities"/>
          </template>
        </Dialog>

        <Galleria :value="images" :responsiveOptions="responsiveOptions" :numVisible="7"
                  containerStyle="max-width: 850px"
                  :circular="true" :fullScreen="true" :showItemNavigators="true" :showThumbnails="false"
                  :visible.sync="displayGallery">
          <!--                  v-model:visible="displayGallery">-->
          <template #item="slotProps">
            <img :src="slotProps.item.itemImageSrc" :alt="slotProps.item.alt" style="width: 100%; display: block;"/>
          </template>
          <template #thumbnail="slotProps">
            <img :src="slotProps.item.thumbnailImageSrc" :alt="slotProps.item.alt" style="display: block;"/>
          </template>
        </Galleria>

      </div>
    </div>
  </div>

</template>

<script>
  import CharityService from '../../services/CharityService';
  import UserService from '../../services/UserService';
  import {ScaleOut} from 'vue-loading-spinner';

  export default {
    components: { ScaleOut },
    data() {
      return {
        charities: null,
        charityDialog: false,
        deleteCharityDialog: false,
        deleteCharitiesDialog: false,
        charity: {},
        selectedCharities: null,
        filters: {},
        submitted: false,
        displayGallery: false,
        images: [],
        responsiveOptions: [
          {
            breakpoint: '1024px',
            numVisible: 5
          },
          {
            breakpoint: '768px',
            numVisible: 3
          },
          {
            breakpoint: '560px',
            numVisible: 1
          }
        ],
        user_accesses: this.$store.state.accesses,
        userService: null,
        charityService: null
      }
    },
    created() {
      this.charityService = new CharityService();
      this.userService = new UserService();
      if (!this.user_accesses){
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      this.charityService.listCharities().then(response => this.charities = response.data.charities);
    },
    methods: {
      formatCurrency(value) {
        return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
      },
      openNew() {
        this.$router.push('/charity').catch()
      },
      showGallery(charity) {
        this.charity = this.charities[this.findIndexById(charity.id)];
        this.images = [
          {
            "itemImageSrc": 'assets/layout/images/charities/' + charity.image,
            "thumbnailImageSrc": 'assets/layout/images/charities/' + charity.image,
            "alt": charity.name,
            "title": charity.name
          }
        ];
        // this.products = this.products.filter(val => val.id === product.id);
        this.displayGallery = !this.displayGallery;
      },
      // openNew() {
      //   this.$router.push('/carpark')
      //   // this.product = {};
      //   // this.submitted = false;
      //   // this.productDialog = true;
      // },
      hideDialog() {
        this.charityDialog = false;
        this.submitted = false;
      },
      saveCharity() {
        this.submitted = true;

        if (this.charity.name.trim()) {
          if (this.charity.id) {
            this.$set(this.charities, this.findIndexById(this.charity.id), this.charity);
            this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Charity Updated', life: 3000});
          } else {
            this.charity.id = this.createId();
            this.charity.code = this.createId();
            this.charity.image = 'product-placeholder.svg';
            this.charity.status = 'INSTOCK';
            this.charities.push(this.charity);
            this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Charity Created', life: 3000});
          }

          this.charityDialog = false;
          this.charity = {};
        }
      },
      editCharity(charity) {
        localStorage.removeItem("charity_info");
        this.charity = {...charity};
        this.$router.push('/charity/edit/' + this.charity.id).catch()
      },
      confirmDeleteCharity(charity) {
        this.charity = charity;
        this.deleteCharityDialog = true;
      },
      deleteCharity() {
        this.charityService.deleteCharities([this.charity.id]).then(result => {
          if (result.status === 200) {
            this.charities = this.charities.filter(val => val.id !== this.charity.id);
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Charity Deleted!',
              life: 3000
            });
            this.deleteCharityDialog = false;
            this.charity = {};
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete!',
              detail: result.data.error
            });
          }
        });
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.charities.length; i++) {
          if (this.charities[i].id === id) {
            index = i;
            break;
          }
        }

        return index;
      },
      createId() {
        let id = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteCharitiesDialog = true;
      },
      deleteSelectedCharities() {
        this.charityService.deleteCharities(this.selectedCharities.map((obj) => obj.id)).then(result => {
          if (result.status === 200) {
            this.charities = this.charities.filter(val => !this.selectedCharities.includes(val));
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Selected Charities Deleted!',
              life: 3000
            });
            this.selectedCharities = null;
            this.deleteCharitiesDialog = false;
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete!',
              detail: result.data.error
            });
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-image {
    width: 100px;
    border-radius: 2em;

    &:hover {
      cursor: pointer;
    }
    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);*/
  }

  .p-dialog .product-image {
    width: 150px;
    margin: 0 auto 2rem auto;
    display: block;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;

    &.status-active {
      background: #C8E6C9;
      color: #256029;
    }

    &.status-inactive {
      background: #FFCDD2;
      color: #C63737;
    }
  }
</style>
